function getErrorMessage(error: any): string {
  return (
    error &&
    ((error as any).error?.message ??
      (error as any).error?.error ??
      (error as any).error_description ??
      (error as any).developerMessage ??
      'Vyskytla sa neočakávaná chyba')
  )
}

/**
 * Pulls the (already-translated) message off a thrown api2 error. The backend
 * sends `message` as a string or an array; falls back when missing.
 * Returns null when there is no error at all — callers render nothing on mount.
 * (Overloady: ak je error typovo non-null — napr. `err` v onError — vracia vždy string.)
 */
function getApiErrorMessage(
  error: NonNullable<unknown>,
  fallback: string
): string
function getApiErrorMessage(error: unknown, fallback: string): string | null
function getApiErrorMessage(error: unknown, fallback: string): string | null {
  if (error == null) return null
  const message = (error as { error?: { message?: string | string[] } })?.error
    ?.message
  if (Array.isArray(message)) return message.join(' ')
  return message ?? fallback
}

export { getErrorMessage, getApiErrorMessage }
